"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getClientSideSplitTreatments_1 = __importDefault(require("./getClientSideSplitTreatments"));
var getServerSideSplitTreatments_1 = __importDefault(require("./getServerSideSplitTreatments"));
var isClientSide_1 = __importDefault(require("./isClientSide"));
var getSplitTreatmentsInGetInitialProps = function (treatmentNames, splitKey, _a) {
    var _b = _a === void 0 ? {} : _a, attributes = _b.attributes, apiPathString = _b.apiPathString;
    if ((0, isClientSide_1.default)()) {
        return (0, getClientSideSplitTreatments_1.default)(treatmentNames, splitKey, {
            apiPathString: apiPathString,
            attributes: attributes,
        });
    }
    return (0, getServerSideSplitTreatments_1.default)(treatmentNames, splitKey, {
        attributes: attributes,
    });
};
exports.default = getSplitTreatmentsInGetInitialProps;
